var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.paymentRequestER
      ? _c(
          "div",
          [
            _c(
              "h2",
              { attrs: { tabindex: "-1" } },
              [
                _c("plain-text-control", {
                  attrs: { title: "PaymentRequestER.AidTargetInformation" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dl",
              { attrs: { id: "aidTargetDescriptionForPaymentRequest" } },
              [
                _c(
                  "dd",
                  [
                    _c("text-label-row", {
                      attrs: {
                        title: "PaymentPlan.Information.AidTargetNumber",
                        labelClass: "col-9 col-md-5 col-xl-3",
                        valueClass: "col-3",
                        value: _vm.aidTargetNumber,
                        alignRight: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "dd",
                  [
                    _c("text-label-row", {
                      attrs: {
                        title:
                          "PaymentPlan.Information.WithdrawableAmountTotal",
                        labelClass: "col-9 col-md-5 col-xl-3",
                        valueClass: "col-3",
                        formatNumber: true,
                        value: _vm.withdrawableAmount.toString(),
                        sign: "€",
                        alignRight: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.aidYearAmounts
                  ? _c(
                      "dd",
                      _vm._l(_vm.aidYearAmounts, function(
                        aidYearAmount,
                        index
                      ) {
                        return _c("text-label-row", {
                          key: index,
                          attrs: {
                            title: _vm.getAidYearAmountTitle(aidYearAmount),
                            doNotUseResources: true,
                            labelClass: "col-9 col-md-5 col-xl-3",
                            valueClass: "col-3",
                            formatNumber: true,
                            value: aidYearAmount.withdrawableAmount.toString(),
                            sign: "€",
                            alignRight: true
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "group-wrapper mb-3" }, [
              _c(
                "div",
                { staticClass: "heading-div" },
                [
                  _c("header-control", {
                    attrs: { title: "PaymentRequestER.PaymentRequest" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "group-content" },
                [
                  _c("radio-button-row", {
                    key: _vm.paymentRadioButtonValueChanged,
                    attrs: {
                      title: "PaymentRequestER.IsPaymentRequest",
                      required: true,
                      rules: {
                        bothNotFalse: "@PaymentRequestER.IsExpenseReport"
                      },
                      disabled: !_vm.allowPaymentRequest
                    },
                    model: {
                      value: _vm.paymentRequestER.isPaymentRequest,
                      callback: function($$v) {
                        _vm.$set(_vm.paymentRequestER, "isPaymentRequest", $$v)
                      },
                      expression: "paymentRequestER.isPaymentRequest"
                    }
                  }),
                  _vm._v(" "),
                  _vm.paymentRequestER.isPaymentRequest
                    ? _c("numeric-input-row", {
                        attrs: {
                          title: "PaymentRequestER.RequestedAmount",
                          id: "requestedamount",
                          required: true,
                          rules: {
                            min_value: 1,
                            max_value: _vm.withdrawableAmount
                          }
                        },
                        model: {
                          value: _vm.paymentRequestER.requestedAmount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.paymentRequestER,
                              "requestedAmount",
                              $$v
                            )
                          },
                          expression: "paymentRequestER.requestedAmount"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "group-wrapper mb-3" }, [
              _c(
                "div",
                { staticClass: "heading-div" },
                [
                  _c("header-control", {
                    attrs: {
                      title: "PaymentRequestER.ExpenseReport.Title",
                      instructionKey:
                        "PaymentRequestER.ExpenseReport.Title_Instructions"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "group-content" },
                [
                  _c("radio-button-row", {
                    key: _vm.expenseRadioButtonValueChanged,
                    attrs: {
                      title: "PaymentRequestER.IsExpenseReport",
                      required: true,
                      rules: {
                        bothNotFalse: "@PaymentRequestER.IsPaymentRequest",
                        required: _vm.noWithdrawable
                          ? { allowFalse: false }
                          : true
                      },
                      disabled: !_vm.allowExpenseReport
                    },
                    model: {
                      value: _vm.paymentRequestER.isExpenseReport,
                      callback: function($$v) {
                        _vm.$set(_vm.paymentRequestER, "isExpenseReport", $$v)
                      },
                      expression: "paymentRequestER.isExpenseReport"
                    }
                  }),
                  _vm._v(" "),
                  _vm.paymentRequestER.isExpenseReport
                    ? _c(
                        "div",
                        [
                          _c("aid-year-select", {
                            attrs: {
                              title:
                                "PaymentRequestER.ExpenseReport.AccountingPeriod",
                              options: _vm.accountingPeriodOptions,
                              required: true,
                              value: _vm.accountingPeriod,
                              dropdownId: "accountingperiod"
                            },
                            on: {
                              input: function($event) {
                                return _vm.setAccountingPeriod($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.expenseReport.crmAidYearId
                            ? _c("text-label-row", {
                                attrs: {
                                  title:
                                    "PaymentRequestER.ExpenseReport.PreviouslyReportedExpenses",
                                  id: "expenditurecleared",
                                  formatNumber: true,
                                  sign: "€"
                                },
                                model: {
                                  value: _vm.expenditureCleared.toString(),
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.expenditureCleared,
                                      "toString()",
                                      $$v
                                    )
                                  },
                                  expression: "expenditureCleared.toString()"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("numeric-input-row", {
                            attrs: {
                              title:
                                "PaymentRequestER.ExpenseReport.AidTargetOtherProfit",
                              id: "aidtargetotherprofit",
                              required: true
                            },
                            model: {
                              value: _vm.expenseReport.aidTargetOtherProfit,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.expenseReport,
                                  "aidTargetOtherProfit",
                                  $$v
                                )
                              },
                              expression: "expenseReport.aidTargetOtherProfit"
                            }
                          }),
                          _vm._v(" "),
                          _c("numeric-input-row", {
                            attrs: {
                              title:
                                "PaymentRequestER.ExpenseReport.AidTargetExpenses",
                              id: "aidtargetexpenses",
                              required: true,
                              rules: { min_value: 1 }
                            },
                            model: {
                              value: _vm.expenseReport.aidTargetExpenses,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.expenseReport,
                                  "aidTargetExpenses",
                                  $$v
                                )
                              },
                              expression: "expenseReport.aidTargetExpenses"
                            }
                          }),
                          _vm._v(" "),
                          _c("text-label-row", {
                            attrs: {
                              title:
                                "PaymentRequestER.ExpenseReport.TotalExpensesToReport",
                              id: "totalexpensestoreport",
                              formatNumber: true,
                              sign: "€"
                            },
                            model: {
                              value: _vm.totalExpensesToReport.toString(),
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.totalExpensesToReport,
                                  "toString()",
                                  $$v
                                )
                              },
                              expression: "totalExpensesToReport.toString()"
                            }
                          }),
                          _vm._v(" "),
                          _c("attachment-table", {
                            staticClass: "mb-3",
                            attrs: {
                              id: "attachments",
                              attachmentNameMaxLength: 50,
                              title: _vm.attachmentsTitle,
                              required: true
                            },
                            model: {
                              value:
                                _vm.paymentRequestER.expenseReport.attachments,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paymentRequestER.expenseReport,
                                  "attachments",
                                  $$v
                                )
                              },
                              expression:
                                "paymentRequestER.expenseReport.attachments"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "PaymentRequestER.AdditionalInformation",
                id: "additionalinformation",
                required: false,
                maxLength: 500,
                rows: 5,
                inputWidth: "col-6"
              },
              model: {
                value: _vm.paymentRequestER.additionalInformation,
                callback: function($$v) {
                  _vm.$set(_vm.paymentRequestER, "additionalInformation", $$v)
                },
                expression: "paymentRequestER.additionalInformation"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }